<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 12L8 23L2 12L8 1L14 12ZM18 12L12.325 22.425L11.175 20.325L15.725 12L11.175 3.675L12.325 1.575L18 12ZM22 12L16.325 22.425L15.175 20.325L19.725 12L15.175 3.675L16.325 1.575L22 12ZM11.725 12L8 5.175L4.275 12L8 18.825L11.725 12Z" fill="currentColor"/>
    </svg>
    